import React from "react";
import styled from "styled-components";

const TitleWrapper = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  font-size: 26px;
  font-weight: 600;

  & > * {
    display: flex;
    margin-right: 18px;
    flex-direction: row;
  }

  @media (max-width: 647px) {
    flex-direction: column;
    & > * {
      flex-direction: column;
    }
  }
`;

const GoalIcon = styled.i`
  color: ${(props) => props?.theme?.darkPurple};
  margin-right: 10px;
  line-height: 32px;
`;

const Title = styled.h3`
  color: ${(props) => props?.theme?.nero};
`;

const Date = styled.span`
  color: ${(props) => props?.theme?.gray};
  @media (max-width: 647px) {
    font-size: 23px;
  }
`;

const GoalsSectionTitle = ({ label, date }) => {
  return (
    <TitleWrapper data-testid="goals-section-title-wrapper">
      <Title>
        <GoalIcon className="fas fa-flag-checkered"></GoalIcon>
        {label}
      </Title>
      <Date>{date}</Date>
    </TitleWrapper>
  );
};

export default GoalsSectionTitle;
